export const ADD_LOCATION = 'ADD_LOCATION';
export const API = 'API';
export const API_START = 'API_START';
export const API_END = 'API_END';
export const API_ERROR = 'API_ERROR';
export const ShowLocations = 'ShowLocations';
export const toast = 'toast'
export const REMOVE_LOCATION = 'REMOVE_LOCATION'
export const SET_LOCATION_FORECAST = 'SET_LOCATION_FORECAST'